import React, { useMemo } from 'react'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import VenuesSelectionCard from '../../../components/UserDashboard/VenuesSelectionCard/VenuesSelectionCard'

const images = [
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0001.jpg', title: 'Romantic First Dance Lights' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0002.jpg', title: 'Golden Hall Reception Elegance' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0003.jpg', title: 'Warm Citrus Table Setting' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0004.jpg', title: 'Rustic Courtyard Dinner Setup' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0005.jpg', title: 'Tropical Beach Floral Table' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0006.jpg', title: 'Vibrant Orchid Cake Display' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0007.jpg', title: 'Elegant Candlelit Reception Hall' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0008.jpg', title: 'Cherry Blossom Ballroom Decor' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0009.jpg', title: 'Mirror Welcome Sign Garden' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0010.jpg', title: 'Sunset Garden Table Setup' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0011.jpg', title: 'Rustic Just Married Banner' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0012.jpg', title: 'Pinecone Groom Place Card' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0013.jpg', title: 'Cozy Nighttime Wedding Gathering' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0014.jpg', title: 'Pastel Bird Centerpiece Table' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0015.jpg', title: 'Blossom Arch Wedding Moment' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0016.jpg', title: 'Minimal Daisy Table Decor' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0017.jpg', title: 'Champagne Toast Celebration' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0018.jpg', title: 'Pink Floral Tiered Cake' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0019.jpg', title: 'Romantic Indoor Wedding Portrait' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0020.jpg', title: 'LGBTQ+ Wedding Celebration' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0021.jpg', title: 'Rustic Greenery Wedding Setup' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0022.jpg', title: 'Elegant White Leaf Cake' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0023.jpg', title: 'Rustic Green Table Setting' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0024.jpg', title: 'Dried Orange Wedding Cake' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0025.jpg', title: 'Amber Floral Table Decor' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0026.jpg', title: 'Blue Accent Reception Table' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0027.jpg', title: 'Candlelit Rustic Table Setup' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0028.jpg', title: 'Blue Floral Wedding Aisle' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0029.jpg', title: 'Rustic Wooden Table Setup' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0030.jpg', title: 'Burlap Wedding Card Station' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0031.jpg', title: 'Beach Blue Wedding Cake' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0032.jpg', title: 'Boho Outdoor Wedding Table' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0033.jpg', title: 'Berry Layered Wedding Cake' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0034.jpg', title: 'Modern Barn Reception Setup' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0035.jpg', title: 'Rustic Loft Wedding Venue' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0036.jpg', title: 'Elegant Ballroom Wedding Reception' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0037.jpg', title: 'Golden Chandelier Wedding Venue' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0038.jpg', title: 'Traditional Bride in Gold' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0039.jpg', title: 'Vibrant Floral Wedding Cake' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0040.jpg', title: 'Chic Minimalist Reception Hall' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0041.jpg', title: 'Mason Jar Table Centerpiece' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0042.jpg', title: 'Black and Gold Tablescape' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0043.jpg', title: 'Rustic Chalkboard Wedding Signs' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0044.jpg', title: 'Golden Candlelit Table Setting' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0045.jpg', title: 'Outdoor Garden Ceremony Setup' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0046.jpg', title: 'Classic Ballroom Wedding Decor' },
	{ src: '/images/receptionvibes/otb_onboarding_wedding_reception_vibe_0047.jpg', title: 'Elegant Ballroom First Dance' },
]

function ReceptionVibe({
  open,
  handleClose,
  handleNext,
  handleBack,
  weddingData,
  setWeddingData,
}) {
  const imageByTitle = useMemo(
    () => Object.fromEntries(images.map((i) => [i.title, i.src])),
    []
  )

  const toggleSelect = (title) => {
  setWeddingData((prev) => {
    const isSelected = prev.receptionVibe.includes(title)
    const nextReceptionVibe = isSelected
      ? prev.receptionVibe.filter((t) => t !== title)
      : [...prev.receptionVibe, title]

    const src = imageByTitle[title]
    const currentImgs = prev.selectedImages || []
    const nextSelectedImages = src
      ? (isSelected ? currentImgs.filter((p) => p !== src) : [...currentImgs, src])
      : currentImgs

    return {
      ...prev,
      receptionVibe: nextReceptionVibe,
      selectedImages: nextSelectedImages,
    }
  })
}

  const handleNextAndSave = async () => {
    try {
      const selectedPaths = (weddingData.receptionVibe || []).map(
        (title) => imageByTitle[title]
      );

      setWeddingData((prev) => ({
        ...prev,
        receptionVibeImages: selectedPaths, 
      }));

      handleNext();
    } catch (e) {
      console.error('Failed to prep reception vibe images:', e?.message)
      handleNext()
    }
  }

  return (
    <NewWedingModal open={open} handleClose={handleClose} handleBack={() => handleBack(2)}>
      <div className={`${styles.welcomeModal}`}>
        <div className={styles.welcomeModalBody}>
          <h2>What's your reception vibe?</h2>
          <p>Select all the photos that contribute to your Dinner’s vibe</p>
          <div style={{ width: '100%', marginTop: '40px' }}>
            <div className={styles.VenuesSelectionImages}>
              {images.map((item, index) => (
                <VenuesSelectionCard
                  key={index}
                  image={item.src}
                  title={item.title}
                  selected={weddingData.receptionVibe.includes(item.title)}
                  onClick={() => toggleSelect(item.title)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className={`${styles.buttonContainer} ${styles.buttonContainerCenter}`}>
          <Stepper activeStep={2.3} />
          <ButtonCustom size="lg" data-cy="wizard-next" onClick={handleNextAndSave}>
            Next
          </ButtonCustom>
        </div>
      </div>
    </NewWedingModal>
  )
}

export default ReceptionVibe